export default __webpack_public_path__ + "static/media/gl.7c2e6884.svg";